<script lang="ts" setup>
import type { EsProduct } from '~layers/app/types/elastic'

export interface Props {
  item: EsProduct
  availableOptions: Array<unknown>
  addedItems: Array<unknown>
}

const { public: config } = useRuntimeConfig()
const props = defineProps<Props>()

const image = computed<string>(() => {
  return props.item.image || `${config.xcdnUrl}media/catalog/product/placeholder/default/Product.FallBack.jpg`
})
</script>

<template>
  <div>
    <div class="added-to-cart__product-visual">
      <AppLink :to="item?.url">
        <img
          :src="useXcdnImage(image, 'f=rs:fit:100:115', item?.name)"
          :alt="item?.name"
        >
      </AppLink>
    </div>
    <div class="added-to-cart__product-info">
      <div class="product-info">
        <div class="product-info__content">
          <span class="product-info__name">
            {{ item?.name }}
          </span>
          <span class="product-info__brand">
            {{ item?.brand?.label }}
          </span>
          <CartAddedItemChilds
            v-if="addedItems?.length"
            :added-items="addedItems"
            :available-options="availableOptions"
          />
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>
